import { useQuery } from "@apollo/client";
import { withJsonFormsMultiEnumProps } from "@jsonforms/react";
import { orderBy } from "lodash";
import { Dropdown } from "pepsico-ds";
import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { getCampaignsName } from "../../../graphql/queries/getCampaignListing";
import { getTranslatedText } from "../../../utils/commons";

const CampaignNameSelectComponent = (props) => {
  const { t } = useTranslation();
  const {
    handleChange,
    label,
    path,
    required,
    visible,
    enabled,
    data,
    uischema,
    className,
  } = props;

  const normalizeSelection = (value) =>
    (Array.isArray(value) ? value : value ? [value] : []).filter(Boolean);

  const [campaignOptions, setCampaignOptions] = useState([]);
  const [selected, setSelected] = useState([]);
  const { data: campaignsData } = useQuery(getCampaignsName, {
    variables: {
      filter: {
        //campaignStatus: "ACTIVE",
      },
    },
    fetchPolicy: "cache-first",
  });

  useEffect(() => {
    if (campaignsData) {
      const sortedCampaigns = orderBy(
        campaignsData.listCampaigns,
        ["title"],
        ["asc"]
      );
      setCampaignOptions(sortedCampaigns);
      const formattedData = uischema.returnStringFormat
        ? data?.split(",").map((item) => item.trim())
        : data;

      if (formattedData?.length) {
        setSelected(
          formatOptions(
            normalizeSelection(formattedData).map(
              (item) => sortedCampaigns.find((option) => option.id === item) || {}
            )
          )
        );
      } else {
        setSelected([]);
      }
    }
  }, [campaignsData, data, uischema?.returnStringFormat]);

  const formatOptions = (options) =>
    options.map((option) => ({
      id: option.id,
      displayText: option.title,
    }));
  const formatData = (value) => normalizeSelection(value).map((item) => item.id);

  const formattedCampaignOptions = useMemo(
    () => formatOptions(campaignOptions),
    [campaignOptions]
  );

  const handleSelectValue = (val) => {
    if (!val && uischema.selection === "single" && selected.length === 0) return;

    const normalizedValue = normalizeSelection(val);
    setSelected(normalizedValue);
    const formatedData = uischema.returnStringFormat
      ? formatData(normalizedValue).join(",")
      : formatData(normalizedValue);
    handleChange(path, formatedData);
  };

  return visible ? (
    <div className="multiple-select-wrap peacock-dropdown-show-label">
      <Dropdown
        childList={formattedCampaignOptions}
        selection={uischema.selection || "multiple"}
        isRequired={required}
        label={getTranslatedText(t, label, label)}
        disabled={!enabled}
        selectedValue={selected}
        className={className}
        placeholder={getTranslatedText(
          t,
          uischema?.placeholder,
          uischema?.placeholder || "Select"
        )}
        setSelectedValue={(val) => handleSelectValue(val)}
      />
    </div>
  ) : null;
};

CampaignNameSelectComponent.propTypes = {
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  path: PropTypes.string.isRequired,
  required: PropTypes.bool,
  visible: PropTypes.bool,
  enabled: PropTypes.bool,
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  className: PropTypes.string,
};

export const CampaignNameSelectControl = withJsonFormsMultiEnumProps(
  CampaignNameSelectComponent
);

export { CampaignNameSelectComponent };
